import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1">
            {item.to && !last ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {!last && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </span>
        );
      })}
    </nav>
  );
}